import routePaths from '@/seo/routes.json';

const SiteLayout = () => import(/* webpackChunkName: "site-layout" */ './SiteLayout.vue');
const Home = () => import(/* webpackChunkName: "site-home" */ './views/Home.vue');
const NotFound = () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue');

export default {
  path: routePaths.site.home,
  component: SiteLayout,
  meta: {
    namespace: 'site',
  },
  children: [
    {
      path: '',
      name: 'home',
      component: Home,
      meta: {
        namespace: 'site',
        searchScope: null,
      },
    },
    {
      path: '*',
      name: 'site-not-found',
      component: NotFound,
      meta: {
        namespace: 'site',
        searchScope: null,
      },
    },
  ],
};
